/**
 * Landing v2 — central CTA destinations.
 *
 * Keeps all Try-Now / login / signup / contact-form anchors in one place so
 * design changes don't drift across the four landing pages.
 */
import { useLocation } from 'react-router-dom';

export const LANDING_CTA = {
  TRY_NOW_STUDENT: '/auth/student',
  TRY_NOW_PARENT: '/auth/parent',
  // School page uses Contact Us (no direct signup — schools onboard via invite)
  CONTACT_ANCHOR: '#contact',
};

export const PAGE_SOURCE = {
  HOME: 'home',
  STUDENT: 'student',
  PARENT: 'parent',
  SCHOOL: 'school',
};

/**
 * Returns the landing base path so the same components work both during
 * staging (mounted at /landing-v2) and after cut-over (mounted at /).
 */
export function useLandingBase() {
  const location = useLocation();
  return location.pathname.startsWith('/landing-v2') ? '/landing-v2' : '';
}
